"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductsDataProvider = function () {
  function ProductsDataProvider(ProductsService, db) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ProductsDataProvider);
    this.ProductsService = ProductsService;
    this.products = db.getCollection("products");
    this.db = db;
  }

  (0, _createClass3.default)(ProductsDataProvider, [{
    key: "getProducts",
    value: function getProducts() {
      return this.products.find({});
    }
  }, {
    key: "loadProducts",
    value: function loadProducts(forceReload) {
      var _this = this;

      return this.ProductsService.loadAllProducts().then(function (products) {
        _this.products.insert(products);
        return products;
      });
    }
  }, {
    key: "loadProductMaterials",
    value: function loadProductMaterials(slug) {
      var _this2 = this;

      var product = this.db.getCollection('products').findOne({ slug: slug }),
          service = this.ProductsService;

      return service.loadProductMaterials(product.id).then(function (materials) {
        product.materials = materials;
        _this2.products.update(product);
        return materials;
      });
    }
  }, {
    key: "loadProductMaterialsSpec",
    value: function loadProductMaterialsSpec(productSlug, materialSlug) {
      var _this3 = this;

      var product = this.db.getCollection('products').findOne({ slug: productSlug }),
          service = this.ProductsService,
          material = product.materials.find(function (material) {
        return material.slug == materialSlug;
      });
      return service.loadProductMaterialSpec(product.id, material.id).then(function (spec) {
        material.spec = spec;
        _this3.products.update(product);
        return spec;
      });
    }
  }, {
    key: "loadProductMaterialPricing",
    value: function loadProductMaterialPricing(productSlug, materialSlug) {
      var _this4 = this;

      var product = this.db.getCollection('products').findOne({ slug: productSlug }),
          service = this.ProductsService,
          material = product.materials.find(function (material) {
        return material.slug == materialSlug;
      });
      return service.loadProductMaterialPricing(productSlug, materialSlug).then(function (pricing) {
        material.pricing = pricing;
        _this4.products.update(product);
        return pricing;
      });
    }
  }, {
    key: "saveProductMaterialPricing",
    value: function saveProductMaterialPricing(productSlug, materialSlug, spec) {
      var _this5 = this;

      var product = this.db.getCollection('products').findOne({ slug: productSlug }),
          service = this.ProductsService,
          material = product.materials.find(function (material) {
        return material.slug == materialSlug;
      });
      return service.saveProductMaterialPricing(productSlug, materialSlug, spec).then(function (resp) {
        material.pricing = spec;
        _this5.products.update(product);
        return resp;
      });
    }
  }, {
    key: "addProductMaterialShape",
    value: function addProductMaterialShape(productId, materialId, shapeId) {
      var _this6 = this;

      var product = this.db.getCollection('products').findOne({ id: productId }),
          service = this.ProductsService,
          material = product.materials.find(function (material) {
        return material.id == materialId;
      }),
          shapes = material.spec.shapes;

      return service.addProductMaterialShape(productId, materialId, shapeId).then(function (shape) {
        shapes.push(shape, 1);
        _this6.products.update(product);
        return shape;
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: "deleteProductMaterialShape",
    value: function deleteProductMaterialShape(productId, materialId, shapeId) {
      var _this7 = this;

      var product = this.db.getCollection('products').findOne({ id: productId }),
          service = this.ProductsService,
          material = product.materials.find(function (material) {
        return material.id == materialId;
      }),
          shapes = material.spec.shapes,
          shapeIdx = shapes.findIndex(function (shape) {
        return shape.id == shapeId;
      });
      return service.deleteProductMaterialShape(productId, materialId, shapeId).then(function (shape) {
        //delete from storage on successful api call
        shapes.splice(shapeIdx, 1);
        _this7.products.update(product);
        return shape;
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: "addProductMaterialColor",
    value: function addProductMaterialColor(productId, materialId, colorId) {
      var _this8 = this;

      var product = this.db.getCollection('products').findOne({ id: productId }),
          service = this.ProductsService,
          material = product.materials.find(function (material) {
        return material.id == materialId;
      }),
          colors = material.spec.colors;

      return service.addProductMaterialColor(productId, materialId, colorId).then(function (color) {
        colors.push(color, 1);
        _this8.products.update(product);
        return color;
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: "deleteProductMaterialColor",
    value: function deleteProductMaterialColor(productId, materialId, colorId) {
      var _this9 = this;

      var product = this.db.getCollection('products').findOne({ id: productId }),
          service = this.ProductsService,
          material = product.materials.find(function (material) {
        return material.id == materialId;
      }),
          colors = material.spec.colors,
          colorIdx = colors.findIndex(function (color) {
        return color.id == colorId;
      });
      return service.deleteProductMaterialColor(productId, materialId, colorId).then(function (color) {
        //delete from storage on successful api call
        colors.splice(colorIdx, 1);
        _this9.products.update(product);
        return color;
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: "updateName",
    value: function updateName(data, type) {
      var dataS = { id: data.id, name: data.name, slug: data.slug };
      return this.ProductsService.updateName(dataS, type).then(function (result) {
        return result;
      });
    }
  }]);
  return ProductsDataProvider;
}();

// WEBPACK FOOTER //


exports.default = ProductsDataProvider;


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/services/products.dataprovider.service.js
 **/